import { Separator } from '@/components/ui/separator.tsx';
import { RiFacebookCircleFill, RiInstagramLine, RiPinterestFill } from 'react-icons/ri';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button.tsx';

export function Footer() {
  return (
    <footer className="py-8 border-t mt-16">
      <div className="container mx-auto text-center">
        <div className="flex items-center space-x-4 h-5 justify-center py-8">
          <Link to="/about" className="link" viewTransition>
            About
          </Link>
          <Separator orientation={'vertical'} className="h-8!" />
          <Link to="/contact" className="link" viewTransition>
            Contact Us
          </Link>
          <Separator orientation={'vertical'} className="h-8!" />
          <Link to="/privacy-policy" className="link" viewTransition>
            Privacy Policy
          </Link>
        </div>
        <div>&copy; {new Date().getFullYear()} Sacco Carpet. All rights reserved.</div>
        <div className="flex items-center space-x-4 justify-center py-8">
          <Button variant="ghost" size="icon">
            <a href="https://instagram.com/saccocarpet" target="_blank">
              <RiInstagramLine className="size-8" />
            </a>
          </Button>
          <Button variant="ghost" size="icon">
            <a href="https://www.facebook.com/SaccoCarpet" target="_blank">
              <RiFacebookCircleFill className="size-8" />
            </a>
          </Button>
          <Button variant="ghost" size="icon">
            <a href="https://www.pinterest.com/saccocarpet" target="_blank">
              <RiPinterestFill className="size-8" />
            </a>
          </Button>
        </div>
      </div>
    </footer>
  );
}
